module.exports = __webpack_public_path__ + "img/persistent_confirmations.2d310f41.svg";